<template>
  <!--begin::App-->
  <div class="app-root" id="kt_app_root">
    <!--begin::Page-->
    <div class="app-page" id="kt_app_page">
      <div class="login p-4">
        <div class="container h-100">
          <div class="d-flex flex-column flex-lg-row justify-content-lg-between bg-white br-40 h-100">
            <div class="col-12 col-lg-6 order-1 order-lg-0">
              <div class="d-flex flex-column justify-content-center h-100 p-10">
                <router-link class="logo" :to="'/'">
                  <img src="/images/layout/logo-pixel-principal.png" alt="Pixel Roads" />
                </router-link>
                <h1 class="font3 font-size-large font-size-md-xxLarge fw-300">
                  {{ $t('the') }} <span class="fw-700">{{ $t('right_ad') }}</span> {{ $t('right') }}<br>
                  {{ $t('at_the_ideal_time') }}
                </h1>
                <div class="login-form">
                  <form class="default-form" @submit.prevent="login">
                    <div class="form-group mb-4">
                      <label class="form-label font-size-regular font3">{{ $t('email') }}</label>
                      <input type="email" class="form-control form-control-sm" :placeholder="$t('enter_your_email')" v-model.trim="$v.form.email.$model" />
                    </div>
                    <div class="form-group">
                      <label class="form-label font-size-regular font3">{{ $t('password') }}</label>
                      <input type="password" class="form-control form-control-sm" :placeholder="$t('enter_your_password')" v-model.trim="$v.form.password.$model" autocomplete="new-password" />
                    </div>
                    <div class="mt-5">
                      <Button
                        type="submit"
                        class="btn-color5 btn-lg fw-500 w-100"
                        :disabled="$v.$invalid"
                        :loading="loader"
                      >
                        {{ $t('enter_now') }}
                      </Button>
                    </div>
                    <div class="mt-5 text-center font-size-small">
                      {{ $t('dont_have_an_account') }}
                      <router-link :to="{ name: 'registration' }" class="link-color5 text-decoration-underline">
                        {{ $t('sign_up_now') }}
                      </router-link>
                      <span> | </span>{{ $t('forgot_password') }}
                      <router-link :to="{ name: 'forgot.password' }" class="link-color5 text-decoration-underline">
                        {{ $t('click_here') }}
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6 order-0 order-lg-1 d-none d-lg-block position-relative text-end login-image">
              <div class="h-100">
                <div class="position-absolute w-100 d-flex justify-content-end">
                  <select v-model="$i18n.locale" id="language" class="form-select font-size-small border-0 w-auto" @change="handleLanguageChange">
                    <option value="pt_BR">PT</option>
                    <option value="en" selected>EN</option>
                    <option value="es">ES</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TheFooter />
    </div>
  <!--end::Page-->
  </div>
  <!--end::App-->
</template>

<script>

import AuthService from '@/modules/auth/services/auth-service'
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import UsersService from '@/modules/users/services/users-service'

import Button from '@/components/common/Button/Button'
import TheFooter from '@/components/footers/TheFooter2'

export default {
  name: 'Login',
  components: {
    Button,
    TheFooter
  },
  data () {
    return {
      // registrationStep: 'registration',
      // userEmail: '',
      loader: false,
      form: {
        email: '',
        password: ''
      }
    }
  },
  validations () {
    return {
      form: {
        email: { email, required },
        password: { required }
      }
    }
  },
  created () {
    this.handleLanguage()
  },
  methods: {
    ...mapActions('auth', ['setRegistrationData', 'set2fAuthentication']),
    async handleLanguage () {
      const language = await UsersService.getCookie('user_language')
      if (language) {
        this.$i18n.locale = language
      } else {
        await UsersService.setCookie('user_language', 'pt_BR', 30)
        this.$i18n.locale = 'pt_BR'
      }
    },
    async handleLanguageChange () {
      await UsersService.setCookie('user_language', this.$i18n.locale, 30)
    },
    /**
     * Login user
     */
    async login () {
      this.loader = true
      try {
        const response = await AuthService.login(this.form)
        window.dataLayer.push({
          event: 'login',
          event_category: 'login',
          event_label: 'Login'
        })
        // If user email is not verified, show verification modal
        if (!response.is_email_verified) {
          this.setRegistrationData({
            step: 'verification',
            email: response.email
          })
          this.$router.push({ name: 'registration' })
        } else if (response.use_2fa) {
          this.set2fAuthentication({
            email: response.email
          })
          this.$router.push({ name: '2f.authentication' })
        } else {
          location.reload()
        }
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
      // return
    }
  }
}
</script>

<style lang="scss" scoped>
  .logo {
    margin-bottom: 30px;
    img {
      width: 150px;
    }
  }

  .app-page {
    flex-direction: column;
    overflow: hidden;
    background: #F8F9FA;
  }

  .app-root, .app-page {
    @media (min-height: 768px) {
      height: 100%;
    }
    @media (min-height: 1200px) {
      height: auto;
    }
  }

  .login {
    background: #ECD263;
    height: 100%;
  }

  .login-image {
    border-radius: 0 0 40px 0;
    max-height: 100%;
    background: url('/images/v2/layout/image-login.jpg') no-repeat;
    background-size: cover;
  }
</style>
